/* Delegation survives Dawn drawer section replacement. */
(() => {
  if (window.npmCartUpgradeInitialized) return;
  window.npmCartUpgradeInitialized = true;
  let busy = false;
  const request = async (url, body) => {
    let response;
    let data;
    try {
      response = await fetch(url, body ? {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      } : { headers: { Accept: 'application/json' } });
      data = await response.json();
    } catch (cause) {
      const error = new Error('Cart response could not be confirmed.', { cause });
      error.uncertain = true;
      throw error;
    }
    if (!response.ok || data.errors || data.status >= 400) {
      throw new Error(data.description || data.errors || window.cartStrings.error);
    }
    return data;
  };
  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-npm-upgrade]');
    if (!button) return;
    event.preventDefault();
    if (busy || button.disabled) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    busy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    drawer.setAttribute?.('aria-busy', 'true');
    const cartItems = drawer.querySelector('cart-drawer-items');
    cartItems?.classList.add('cart__items--disabled');
    const status = button.closest('[data-npm-widget]').querySelector('[role="status"]');
    status.textContent = '';
    const showError = (message) => {
      const currentStatus = document.getElementById('CartDrawer-CartErrors') || status;
      currentStatus.textContent = message;
    };
    const sourceKey = button.dataset.sourceKey;
    const sections = drawer.getSectionsToRender().map((section) => section.id);
    const sectionBody = { sections, sections_url: window.location.pathname };
    // Private identity isolates this add for compensation even if its response is lost.
    const transaction = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
    let added;
    let removed = false;
    let uncertainRemoval = false;
    let uncertainAdd = false;
    const render = async (state) => {
      if (!state.sections || sections.some((id) => !state.sections[id])) {
        state.sections = await request(`${routes.cart_url}?sections=${sections.join(',')}`);
      }
      drawer.classList.toggle('is-empty', state.item_count === 0);
      drawer.renderContents(state);
      if (typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'npm-cart-upgrade', cartData: state });
      }
    };
    try {
      let targetVariant = Number(button.dataset.targetVariant);
      if (button.dataset.targetVariants) {
        const variant = JSON.parse(button.dataset.targetVariants).find((candidate) => candidate.available &&
          (candidate.title === button.dataset.variantTitle || candidate.options.includes(button.dataset.variantTitle)));
        if (!variant) throw new Error(window.cartStrings.error);
        targetVariant = variant.id;
      }
      try {
        const result = await request(routes.cart_add_url, {
          items: [{ id: targetVariant, quantity: 1,
            properties: { _npm_source: button.dataset.source, _npm_upgrade: transaction } }],
        });
        added = result.items.find((item) => Number(item.id) === Number(targetVariant));
        if (!added?.key) throw new Error(window.cartStrings.error);
      } catch (error) {
        if (error.uncertain) {
          uncertainAdd = true;
          const current = await request(`${routes.cart_url}.js`);
          uncertainAdd = false;
          added = current.items.find((item) => item.properties?._npm_upgrade === transaction);
        }
        throw error;
      }
      let state;
      try {
        state = await request(routes.cart_change_url, { id: sourceKey, quantity: 0, ...sectionBody });
        if (state.items.some((item) => item.key === sourceKey)) throw new Error(window.cartStrings.error);
        removed = true;
      } catch (error) {
        // A lost response can follow a committed removal. Read cart before compensating.
        if (error.uncertain) {
          uncertainRemoval = true;
          const current = await request(`${routes.cart_url}.js`);
          uncertainRemoval = false;
          if (!current.items.some((item) => item.key === sourceKey)) {
            removed = true;
            state = current;
          }
        }
        if (!removed) throw error;
      }
      await render(state);
    } catch (error) {
      if (uncertainRemoval || uncertainAdd) {
        showError('Please check your cart before trying again. The replacement could not be confirmed.');
        return;
      }
      if (added && !removed) {
        try {
          const rollback = await request(routes.cart_change_url, { id: added.key, quantity: 0, ...sectionBody });
          if (rollback.items.some((item) => item.key === added.key)) throw new Error(window.cartStrings.error);
          await render(rollback);
        } catch {
          showError('Please check your cart before trying again. The replacement could not be reversed.');
          return;
        }
      }
      showError(window.cartStrings.error);
    } finally {
      busy = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      drawer.removeAttribute?.('aria-busy');
      cartItems?.classList.remove('cart__items--disabled');
    }
  });
})();
